import React from 'react';

export function ProductNavIcon({ type }) {
  if (type === 'spark') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4.5" y="4.5" width="6" height="6" rx="1.4" stroke="currentColor" strokeWidth="1.5" />
        <rect x="13.5" y="4.5" width="6" height="6" rx="1.4" stroke="currentColor" strokeWidth="1.5" />
        <rect x="4.5" y="13.5" width="6" height="6" rx="1.4" stroke="currentColor" strokeWidth="1.5" />
        <rect x="13.5" y="13.5" width="6" height="6" rx="1.4" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    );
  }

  if (type === 'flow') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4.5" y="5" width="5.2" height="4.2" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
        <rect x="14.3" y="14.8" width="5.2" height="4.2" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9.7 7.1h3.2c1.1 0 2 .9 2 2v5.7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === 'plug') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M8.5 8.2v3.4M15.5 8.2v3.4M7.2 11.2h9.6v1.1a4.8 4.8 0 0 1-4.8 4.8 4.8 4.8 0 0 1-4.8-4.8v-1.1Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 17v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === 'docs') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M7.2 5.4h7.7l3 3v10.2a1.8 1.8 0 0 1-1.8 1.8H7.2a1.8 1.8 0 0 1-1.8-1.8V7.2a1.8 1.8 0 0 1 1.8-1.8Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M14.9 5.6v3h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.8 11h6.6M8.8 14.1h6.6M8.8 17.2h4.1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === 'blog') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6.2 7.1h11.6a1.5 1.5 0 0 1 1.5 1.5v6.8a1.5 1.5 0 0 1-1.5 1.5H6.2a1.5 1.5 0 0 1-1.5-1.5V8.6a1.5 1.5 0 0 1 1.5-1.5Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8.1 10.2h4.9M8.1 13.1h7.7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="16.3" cy="10.4" r="1.1" fill="currentColor" />
      </svg>
    );
  }

  if (type === 'guide') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 19.5s-4.8-3.2-4.8-8a4.8 4.8 0 1 1 9.6 0c0 4.8-4.8 8-4.8 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <circle cx="12" cy="11.4" r="1.7" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 20v1.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === 'usecase') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="8" cy="8.2" r="2.2" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="16.2" cy="8.2" r="2.2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4.9 17.6c.5-2.3 2.4-3.8 4.9-3.8s4.4 1.5 4.9 3.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M13.5 17.6c.34-1.48 1.52-2.42 3.14-2.42 1.63 0 2.8.94 3.16 2.42" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === 'library') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4.8" y="6" width="14.4" height="12" rx="2.4" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9 9.2h6M9 12h6M9 14.8h3.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M7.2 5v14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === 'alt') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6.2 7.6h11.6M6.2 12h11.6M6.2 16.4h11.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="9.2" cy="7.6" r="1.8" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="15.4" cy="12" r="1.8" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="11.4" cy="16.4" r="1.8" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    );
  }

  // Default/compare icon
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4.8 6.8h6.6M4.8 12h14.4M12.6 17.2h6.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="14.6" cy="6.8" r="1.7" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="9.4" cy="12" r="1.7" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="10.4" cy="17.2" r="1.7" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

export function AboutIcon({ type, className = '' }) {
  if (type === 'star') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="m12 3.4 2.7 5.46 6.03.88-4.36 4.25 1.03 5.99L12 17.17l-5.4 2.81 1.03-5.99-4.36-4.25 6.03-.88L12 3.4Z" />
      </svg>
    )
  }

  if (type === 'wrench') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M21 7.5a4.5 4.5 0 0 1-6.83 3.86L8.3 17.22a1.8 1.8 0 1 1-2.54-2.54l5.86-5.87A4.5 4.5 0 0 1 16.5 3l-2.04 2.04 2.5 2.5L21 7.5Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'search') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="1.8" />
        <path d="m16 16 4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    )
  }

  if (type === 'code') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="m8 8-4 4 4 4M16 8l4 4-4 4M14.5 4 9.5 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'activity') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'server') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="2" y="3" width="20" height="7" rx="2" stroke="currentColor" strokeWidth="1.7" />
        <rect x="2" y="14" width="20" height="7" rx="2" stroke="currentColor" strokeWidth="1.7" />
        <path d="M6 6h.01M6 17h.01" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    )
  }

  if (type === 'globe') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.7" />
        <path d="M12 2a14.5 14.5 0 0 0 0 20M12 2a14.5 14.5 0 0 1 0 20M2 12h20" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      </svg>
    )
  }

  if (type === 'refresh') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M3 12a9 9 0 0 1 15.3-6.36L21 8M21 3v5h-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M21 12a9 9 0 0 1-15.3 6.36L3 16M3 21v-5h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'mail') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="m4 7 8 6 8-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'arrow-right') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'rocket') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 14c-1.2 0-2.4.6-3 1.8L2 18l2.2-1c1.2-.6 1.8-1.8 1.8-3Zm4-2 5.8-5.8a5.6 5.6 0 0 1 4.3-1.6 5.6 5.6 0 0 1-1.6 4.3L12.7 15M10 12l2 2M7 17l-1 4 4-1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'shield') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3.5 5 6v5.6c0 4.4 2.9 7.8 7 8.9 4.1-1.1 7-4.5 7-8.9V6l-7-2.5Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'zap') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M13 2 5 13h6l-1 9 8-11h-6l1-9Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'bot') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="6" y="8" width="12" height="10" rx="3" stroke="currentColor" strokeWidth="1.8" />
        <path d="M12 4v4M9.5 12h.01M14.5 12h.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    )
  }

  if (type === 'monitor') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4" y="5" width="16" height="11" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M10 19h4M12 16v3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    )
  }

  if (type === 'brain') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9.5 4.5a3 3 0 0 0-3 3v.2A3.5 3.5 0 0 0 5 10.5a3.5 3.5 0 0 0 1.5 2.8v.2a3 3 0 0 0 3 3M14.5 4.5a3 3 0 0 1 3 3v.2a3.5 3.5 0 0 1 1.5 2.8 3.5 3.5 0 0 1-1.5 2.8v.2a3 3 0 0 1-3 3M9.5 4.5c.2 1.2 1.1 2 2.5 2s2.3-.8 2.5-2M9.5 16.5c.2-1.2 1.1-2 2.5-2s2.3.8 2.5 2M9 9.5h6M9 12.5h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'message-square') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M7 18.5 3.5 20V6.5A2.5 2.5 0 0 1 6 4h12A2.5 2.5 0 0 1 20.5 6.5v8A2.5 2.5 0 0 1 18 17H8.2L7 18.5Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'heart-pulse') {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7 7-7Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M3.5 12H9l1-1.5 2.1 4.2 1.9-6.4 1.7 3.7h4.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  return null
}

export function WorkflowIcon({ type }) {
  if (type === 'support') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M7.2 7.7h9.6a2.2 2.2 0 0 1 2.2 2.2v5.1a2.2 2.2 0 0 1-2.2 2.2h-4.4l-3.4 2.3v-2.3H7.2A2.2 2.2 0 0 1 5 15V9.9a2.2 2.2 0 0 1 2.2-2.2Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        <path d="M8.9 11.7h6.2M8.9 14.1h4.1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    )
  }

  if (type === 'email') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4.2" y="6.2" width="15.6" height="11.6" rx="2.4" stroke="currentColor" strokeWidth="1.6" />
        <path d="m5.6 8 5.2 4.4a1.9 1.9 0 0 0 2.4 0L18.4 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'scout') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="5.4" stroke="currentColor" strokeWidth="1.6" />
        <path d="m15.2 15.2 4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        <path d="M11 8.4v5.2M8.4 11h5.2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    )
  }

  if (type === 'research') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 5.4h5.2a2 2 0 0 1 2 2v11.2H7a2 2 0 0 1-2-2V5.4Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M19 5.4h-5.2a2 2 0 0 0-2 2v11.2H17a2 2 0 0 0 2-2V5.4Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M7.5 9h2.6M7.5 11.6h2.6M13.9 9h2.6M13.9 11.6h2.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      </svg>
    )
  }

  if (type === 'prep') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4.2" y="5.6" width="15.6" height="13.4" rx="2.2" stroke="currentColor" strokeWidth="1.6" />
        <path d="M4.2 9.6h15.6M8.4 4.2v3M15.6 4.2v3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="m9.4 14.6 1.7 1.7 3.6-3.6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'followup') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M19 12a7 7 0 1 1-2.05-4.95" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M19 5.5V9h-3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 8.4V12l2.4 1.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'triage') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4.4 5.6h15.2l-5.8 7v6.4l-3.6-1.8v-4.6L4.4 5.6Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      </svg>
    )
  }

  if (type === 'chief') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="5.4" y="5.4" width="13.2" height="14.2" rx="2" stroke="currentColor" strokeWidth="1.6" />
        <rect x="9" y="3.6" width="6" height="3.4" rx="1.1" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8.6 11.6h6.8M8.6 14.2h6.8M8.6 16.8h4.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    )
  }

  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 16.8 10.1 13l2.7 2.5 5.2-5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.8 10.5H18v2.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="4.2" y="4.2" width="15.6" height="15.6" rx="3" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  )
}
